import {
  FetchGetUserMenuRoutes,
  FetchGetUserMenu
} from "_private/api/permission";
// import individuationConfig from "@/individuation.config";

const layout =
  $GLOBAL_CONFIG.layout && $GLOBAL_CONFIG.layout.type
    ? $GLOBAL_CONFIG.layout.type
    : "menuTop";
const view = path => () => import(`@/views/${path}`);

/**
 * @description 动态添加路由
 * @author sunxiaodong
 * @param {*} routes
 * @returns
 */
function addComponent(routes) {
  // const newRoutes = routes;
  routes.forEach(item => {
    if (item.component) {
      if (item.component === "layout") {
        item.component = item.component + "/" + layout;
      }
      item.component = view(item.component);
      if (item.meta) {
        item.meta.title = item.title;
      }
    }
    if (item.children) {
      addComponent(item.children);
    }
  });
  // return newRoutes;
}

const permission = {
  state: {
    addRouters: [],
    menus: []
  },
  mutations: {
    SET_ROUTERS(state, payload) {
      state.addRouters = payload;
    },
    SET_MENUS(state, payload) {
      state.menus = payload;
    }
  },
  actions: {
    generateRouterAct({ commit }, data) {
      return new Promise((resolve, reject) => {
        FetchGetUserMenuRoutes(data)
          .then(response => {
            if (
              response.code === 1 &&
              Array.isArray(response.result) &&
              response.result.length
            ) {
              // let newRoutes = addComponent(response.result);
              addComponent(response.result);
              commit("SET_ROUTERS", response.result);
            }
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    generateMenuAct({ commit }, data) {
      return new Promise((resolve, reject) => {
        FetchGetUserMenu(data)
          .then(response => {
            if (response.code === 1 && Array.isArray(response.result)) {
              let menus = [...response.result];
              commit("SET_MENUS", menus);
            }
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};

export default permission;
